import * as fromActions from './employee.actions';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {IAsyncData, IEmployee, ISyncStatus} from '@signal/asp-data-commons';

export interface EmployeeState extends EntityState<IEmployee> {
  // additional entities state properties
  employeeSelectedId: string | null,
  staffMasterSyncStatus: IAsyncData<ISyncStatus>;
  preSignedUrl:string,
  loading: boolean,
  loaded: boolean,
  error: string
}

export const adapter: EntityAdapter<IEmployee> = createEntityAdapter<IEmployee>();

const initialStaffMasterSyncStatus = {
  data: {},
  loaded: false,
  loading: false,
  error: ''
};

export const initialState: EmployeeState = adapter.getInitialState({
  // additional entity state properties
  employeeSelectedId: null,
  staffMasterSyncStatus: initialStaffMasterSyncStatus,
  preSignedUrl:'',
  loading: false,
  loaded: false,
  error: ''
});


export function employeeReducer(
  state: EmployeeState = initialState,
  action: fromActions.EmployeeActions): EmployeeState {

  switch (action.type) {
    case fromActions.EmployeeActionTypes.LOAD_EMPLOYEES: {
      return {
        ...adapter.removeAll(state),
        employeeSelectedId: null,
        staffMasterSyncStatus: state.staffMasterSyncStatus,
        loading: true,
        loaded: false,
        error: ''
      };
    }

    case fromActions.EmployeeActionTypes.LOAD_EMPLOYEES_SUCCESS: {
      return {
        ...adapter.setAll(action instanceof fromActions.LoadEmployeesSuccess ? action.payload.employees : [], state),
        employeeSelectedId: null,
        staffMasterSyncStatus: state.staffMasterSyncStatus,
        loaded: true,
        loading: false,
        error: ''
      };
    }

    case fromActions.EmployeeActionTypes.LOAD_EMPLOYEES_FAILURE: {
      return {
        ...state,
        loaded: false,
        loading: false,
        error: action instanceof fromActions.LoadEmployeesFail ? action.payload.error : ''
      }
    }

    case fromActions.EmployeeActionTypes.LOAD_EMPLOYEE: {
      return {
        ...state,
        employeeSelectedId: action instanceof fromActions.LoadEmployee ? action.payload.employeeId : null
      };
    }

    case fromActions.EmployeeActionTypes.LOAD_EMPLOYEE_SUCCESS: {
      const payload = action instanceof fromActions.LoadEmployeeSuccess ? action.payload : null;
      return {
        ...adapter.setOne(payload.employee, state)
      };
    }
    /*case fromActions.EmployeeActionTypes.LOAD_EMPLOYEE_FAILURE: {
      return produce(state, draftState => {
        draftState.employeeSelectedId = null;
        draftState.loaded = true;
        draftState.staffMasterSyncStatus = state.staffMasterSyncStatus;
        draftState.employees = state.employees;
        draftState.loading = false;
        draftState.error = action instanceof fromActions.LoadEmployeeFail ? action.payload.error : '';
      });
    }*/


    case fromActions.EmployeeActionTypes.UPDATE_EMPLOYEE: {
      const payload = action instanceof fromActions.UpdateEmployee ? action.payload : null;
      return {
        ...adapter.setOne(payload.employee, state)
      };
    }

    case fromActions.EmployeeActionTypes.UPDATE_EMPLOYEE_SUCCESS: {
      const payload = action instanceof fromActions.UpdateEmployeeSuccess ? action.payload : null;
      return {
        ...adapter.setOne(payload.employee, state)
      };
    }

    /*
    case fromActions.EmployeeActionTypes.UPDATE_EMPLOYEE_FAILURE: {
      return produce(state, draftState => {
        draftState.employeeSelectedId = null;
        draftState.loaded = true;
        draftState.staffMasterSyncStatus = state.staffMasterSyncStatus;
        draftState.employees = state.employees;
        draftState.loading = false;
        draftState.error = action instanceof fromActions.UpdateEmployeeFail ? action.payload.error : '';
      });
    } */

    case fromActions.EmployeeActionTypes.UPDATE_TEAM_DETAILS: {
      const payload = action instanceof fromActions.UpdateTeamDetails ? action.payload : null;
      return {
        ...adapter.upsertMany(payload.employees, state)
      };
    }

    case fromActions.EmployeeActionTypes.LOAD_STAFF_MASTER_SYNC_STATUS: {
      return {
        ...state,
        staffMasterSyncStatus: {
          data: state.staffMasterSyncStatus.data,
          loading: true,
          loaded: false,
          error: ''
        }
      };
    }

    case fromActions.EmployeeActionTypes.LOAD_STAFF_MASTER_SYNC_STATUS_SUCCESS: {
      return {
        ...state,
        staffMasterSyncStatus: {
          data: action instanceof fromActions.LoadStaffMasterSyncStatusSuccess ? action.payload.syncStatus : null,
          loading: false,
          loaded: true,
          error: ''
        }
      };
    }

    case fromActions.EmployeeActionTypes.LOAD_STAFF_MASTER_SYNC_STATUS_FAILURE: {
      return {
        ...state,
        staffMasterSyncStatus: {
          data: {},
          loading: false,
          loaded: false,
          error: action instanceof fromActions.LoadStaffMasterSyncStatusFail ? action.payload.error : ''
        }
      };
    }

    case fromActions.EmployeeActionTypes.TRIGGER_STAFF_MASTER_SYNC: {
      return {
        ...state,
        staffMasterSyncStatus: {
          data: state.staffMasterSyncStatus.data,
          loading: true,
          loaded: false,
          error: ''
        }
      };
    }

    case fromActions.EmployeeActionTypes.TRIGGER_STAFF_MASTER_SYNC_SUCCESS: {
      return {
        ...state,
        staffMasterSyncStatus: {
          data: action instanceof fromActions.TriggerStaffMasterSyncSuccess ? action.payload.syncStatus : null,
          loading: false,
          loaded: true,
          error: ''
        }
      };
    }

    case fromActions.EmployeeActionTypes.TRIGGER_STAFF_MASTER_SYNC_FAILURE: {
      return {
        ...state,
        staffMasterSyncStatus: {
          data: {},
          loading: false,
          loaded: false,
          error: action instanceof fromActions.LoadStaffMasterSyncStatusFail ? action.payload.error : ''
        }
      };
    }
   case fromActions.EmployeeActionTypes.LOAD_PRESIGNED_URL_SUCCESS:{
     return {
       ...state,
       preSignedUrl: action instanceof fromActions.LoadPreSignedUrlSuccess ? action.payload.data : null,
     }
   }
    default:
      return state;
  }
}
